var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7831 6.00021L11.3887 1.39466C11.4797 1.28838 11.5272 1.15167 11.5218 1.01185C11.5164 0.872028 11.4585 0.739396 11.3595 0.640454C11.2606 0.541513 11.128 0.48355 10.9881 0.47815C10.8483 0.472749 10.7116 0.520308 10.6053 0.611323L5.99977 5.21688L1.39421 0.605767C1.2896 0.501154 1.14771 0.442383 0.999768 0.442383C0.851823 0.442383 0.709937 0.501154 0.605324 0.605767C0.50071 0.71038 0.441939 0.852266 0.441939 1.00021C0.441939 1.14816 0.50071 1.29004 0.605324 1.39466L5.21643 6.00021L0.605324 10.6058C0.547167 10.6556 0.499934 10.7169 0.466587 10.7858C0.433241 10.8547 0.414502 10.9298 0.411547 11.0063C0.408592 11.0828 0.421483 11.1591 0.449414 11.2304C0.477344 11.3017 0.51971 11.3664 0.573851 11.4206C0.627993 11.4747 0.692741 11.5171 0.764033 11.545C0.835325 11.5729 0.91162 11.5858 0.988131 11.5829C1.06464 11.5799 1.13972 11.5612 1.20864 11.5278C1.27757 11.4945 1.33885 11.4473 1.38866 11.3891L5.99977 6.78354L10.6053 11.3891C10.7116 11.4801 10.8483 11.5277 10.9881 11.5223C11.128 11.5169 11.2606 11.4589 11.3595 11.36C11.4585 11.261 11.5164 11.1284 11.5218 10.9886C11.5272 10.8488 11.4797 10.712 11.3887 10.6058L6.7831 6.00021Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6d10a6d8ad1590435fcbb081459f95e6.svg";
export { ForwardRef as ReactComponent };